//============
// Debugging
//============

var $ = jQuery;
var debug;
var player;

var tinysort =  require('tinysort');
var Flickity = require('flickity');

// window.addEventListener('hashchange', fn, false);
window.onload = fn; // fire on pageload

function fn() {
	var hash_parts = window.location.hash;
	var varName;
	var value;
	if (hash_parts.indexOf("&") === -1) {
		varName = hash_parts;
		varName = varName.substr(varName.indexOf("#") + 1);
		value = varName.substr(varName.indexOf("=") + 1);
		varName = varName.substr(0, varName.indexOf("="));
		if (varName) {
			$('.' + varName).val(value);
			$('.' + varName).prop('value', value);

			if (varName == 'js-filter-by-area') {
				$('.js-click-filter-by-area a[href="' + value + '"]').parent().addClass('active');
			}

			if (varName == 'js-filter-by-language' && value == 'language-all' || varName == 'js-filter-by-area' && value == 'area-all' || varName == 'js-filter-by-spoken-lang' && value == 'speak-all') {

			} else {
				$('.' + varName).trigger('change');
			}
		}
	} else {
		hash_parts = location.hash.split('&', 4);
		for (i in hash_parts) {
			if (hash_parts[i].indexOf('#') === -1) {
				varName = hash_parts[i];
				value = varName.substr(varName.indexOf("=") + 1);
				varName = varName.substr(0, varName.indexOf("="));
			} else {
				varName = hash_parts[i];
				varName = varName.substr(varName.indexOf("#") + 1);
				value = varName.substr(varName.indexOf("=") + 1);
				varName = varName.substr(0, varName.indexOf("="));
			}
			if (varName) {
				$('.' + varName).val(value);
				$('.' + varName).prop('value', value);

				if (varName == 'js-filter-by-area') {
					$('.js-click-filter-by-area a[href="' + value + '"]').parent().addClass('active');
				}

				if (varName == 'js-filter-by-language' && value == 'language-all' || varName == 'js-filter-by-area' && value == 'area-all' || varName == 'js-filter-by-spoken-lang' && value == 'speak-all') {

				} else {
					$('.' + varName).trigger('change');
				}
			}
		}
	}

}

function clearQueryString(stringToSearch) {

}

function sortOutPageString(stringToSearch, value) {
	var hash_parts = window.location.hash;
	var startText, location_start, afterText;
	if (hash_parts.indexOf("&") === -1) {
		if (hash_parts.indexOf(stringToSearch) === -1) {
			if (hash_parts.indexOf('#') === -1) {
				window.location.hash = stringToSearch + '=' + value;
			} else {
				if (hash_parts.length === 1) {
					window.location.hash = stringToSearch + '=' + value;
				} else {
					window.location.hash = window.location.hash + '&' + stringToSearch + '=' + value;
				}
			}
		} else {
			location_start = hash_parts.indexOf(stringToSearch);
			startText = hash_parts.substr(0, location_start);
			afterText = hash_parts.substr(location_start + stringToSearch.length + 1);
			if (hash_parts.substr(stringToSearch.length + 2) != value) {
				window.location.hash = startText + stringToSearch + '=' + value;
			}
		}
	} else {
		if (hash_parts.indexOf(stringToSearch) === -1) {
			window.location.hash = window.location.hash + '&' + stringToSearch + '=' + value;
		} else {
			location_start = hash_parts.indexOf(stringToSearch);
			startText = hash_parts.substr(0, location_start);
			var remainingText = hash_parts.substr(location_start);
			if (remainingText.indexOf("&") === -1) {
				window.location.hash = startText + stringToSearch + '=' + value;
			} else {
				afterText = remainingText.substr(remainingText.indexOf("&"));
				window.location.hash = startText + stringToSearch + '=' + value + afterText;
			}
		}
	}
}

if (location.hostname.match('.dev')) {
	debug = true;
} else {
	debug = false;
}

//==================
// Brochure Builder
//==================

function toggleRemoveBrochure(target) {
	if (!target.parents('li').find('.remove-options').is(':visible')) {
		$('.remove-options:visible').fadeToggle();
	}
	target.parents('li').find('.remove-options').fadeToggle();
}

window.toggleRemoveBrochure = toggleRemoveBrochure;

jQuery('body').on('click', function (event) {
	if ($(event.target).hasClass('btn') && $(event.target).hasClass('remove') || $(event.target).hasClass('removeFromShortlistButton')) {

	} else {
		if ($('.remove-options').is(':visible')) {
			$('.remove-options:visible').fadeToggle();
		}
	}
});

function toggleBrochure(target, post_id, expertise_id, removeFrame, mainAdd, listPage, showOverview) {

	expertise_id = typeof expertise_id !== 'undefined' ? expertise_id : 0;
	removeFrame = typeof removeFrame !== 'undefined' ? removeFrame : false;
	mainAdd = typeof mainAdd !== 'undefined' ? mainAdd : false;
	listPage = typeof listPage !== 'undefined' ? listPage : false;
	var htmlToAdd;
	var currentHTML = target.html();
	if (!target.data('previoushtml') && mainAdd) {
		target.data('previoushtml', target.html());
		htmlToAdd = target.data('previoushtml');
	} else if (mainAdd) {
		htmlToAdd = target.data('previoushtml');
	}
	// console.log(htmlToAdd);
	target.addClass('saving');
	target.html('Saving...');
	if (target.hasClass('added')) {
		jQuery.get("?brochure=remove&post_id=" + post_id + (expertise_id ? '&expertise_id=' + expertise_id : '')).done(function (data) {
			// if(debug) console.log(data);
			target.removeClass('saving');
			target.removeClass('added');

			if (target.hasClass('add-to-brochure')) {
				if (mainAdd && !listPage) {
					$('a.add-to-brochure').removeClass('added');
					$('a.add-to-brochure').html('Add this expertise to your shortlist');
					$('.barrister-details a.add-to-brochure').html(htmlToAdd);
					target.data('previousHtml', target.html());
				} else {
					target.removeClass('added');
					if (listPage) {
						target.html('Add to Shortlist');
					} else {
						target.html('Add this expertise to your shortlist');
					}
				}
			} else {
				if (removeFrame) {
					target.parents('li').remove();
					if ($('.people-list').children().length == 0)
						$('h3.no-results').show();
				} else {
					if (target.parent().parent().children().length <= 2) {
						target.parents('li').remove();
					} else {
						target.parent().slideUp(function () {
							$(this).remove();
						});
					}
				}
			}
			if (!mainAdd) {
				jQuery.get("?brochure=check&id=" + post_id).done(function (data) {
					var data = JSON.parse(data);
					console.log(data.response);
					if (data.response === false) {
						// console.log(data.response);
						var htmlToAdd = 'Add to CV Shortlist';
						$('.barrister-details a.add-to-brochure').removeClass('added');
						$('.barrister-details a.add-to-brochure').html(htmlToAdd);
						$('.count').text(function (i, t) {
							if (Number(t) == 1) {
								$('#brochure-notify').fadeOut('slow');
							}
							return Number(t) - 1;
						});
					}
				}).fail(function () {
					if (debug) console.log("error");
				}).always(function () {

				});
			}
		}).fail(function () {
			if (debug) console.log("error");
		}).always(function () {
			// if(debug) console.log( "finished" );
			if (mainAdd) {
				$('.count').text(function (i, t) {
					if (Number(t) == 1) {
						$('#brochure-notify').fadeOut('slow');
					}
					return Number(t) - 1;
				});
			}
		});
	} else {
		console.log(showOverview);
		jQuery.get("?brochure=add&post_id=" + post_id + (expertise_id ? '&expertise_id=' + expertise_id : '') + "&addOverview=" + showOverview).done(function (data) {
			if (debug) console.log(data);
			target.removeClass('saving');
			target.addClass('added');

			if (target.hasClass('add-to-brochure')) {
				var htmlToAdd = '<span class="icon-tick"></span> In your Shortlist';
				if (mainAdd && !listPage) {
					$('a.add-to-brochure').addClass('added');
					$('a.add-to-brochure').html(htmlToAdd);
				} else {
					target.addClass('added');
					target.html(htmlToAdd);
				}
			}
			if (!mainAdd) {
				jQuery.get("?brochure=check&id=" + post_id).done(function (data) {
					var data = JSON.parse(data);
					if (data.response === true) {
						// console.log(data.response);
						var htmlToAdd = '<span class="icon-tick"></span> In your Shortlist';
						$('.barrister-details a.add-to-brochure').addClass('added');
						$('.barrister-details a.add-to-brochure').html(htmlToAdd);
						if (document.getElementById('brochure-notify').style.display != "block") {
							$('#brochure-notify').fadeIn('slow');
						}
						if (data.size === 1) {
							$('.count').text(function (i, t) {
								return Number(t) + 1;
							});
						}
					}
				})
					.fail(function () {
						if (debug) console.log("error");
					})
					.always(function () {

					});
			}
		})
			.fail(function () {
				if (debug) console.log("error");
			})
			.always(function () {
				if (debug) console.log("finished");
				if (document.getElementById('brochure-notify').style.display != "block") {
					$('#brochure-notify').fadeIn('slow');
				}
				if (mainAdd) {
					$('.count').text(function (i, t) {
						return Number(t) + 1;
					});
				}
			});
	}
}

//make toggleBrochure available globally
window.toggleBrochure = toggleBrochure;


//=================================
// Get latest news posts as JSON
//=================================

// function getPosts(post_type, personalisation, limit, orderby){
//     var postURL = '/wp-json/wp/v2/posts?per_page='+limit;
//     if(personalisation) postURL = postURL + '&filter[practice_areas]=' + personalisation;
// }

function getNews() {
	var postURL = '/wp-json/wp/v2/posts?per_page=3';
	// if(area_of_interest) postURL = postURL + '&filter[category_name]=general-news&filter[practice_areas]=' + area_of_interest;
	// console.log(area_of_interest);
	if (area_of_interest) {
		postURL = postURL + '&filter[category_name]=general-news&filter[practice_areas]=' + area_of_interest;
	} else {
		postURL = postURL + '&filter[category_name]=general-news';
	}

	var $ = jQuery;


	$.getJSON(postURL, function (data) {
		//if(debug) console.log(data);
		if (data.length < 1) {
			// console.log("I aint't got nuffin' guv!");
			$('.news>ul').empty();
			$('.news>ul').append(
				$(document.createElement('li')).html((area_of_interest_nicename ? area_of_interest_nicename + ' has' : 'There are') + ' no news posts available, <a href="#" class="remove_personalisation_link">remove personalisation?</a>')
			);
			$('a.remove_personalisation_link').bind('click', function (e) {
				remove_personalisation_link();
				e.preventDefault();
			});
		} else {
			$('.news>ul').empty(); // Remove existing articles
			$(data).each(function (index, item) {
				$('.news>ul').append(
					$(document.createElement('li')).html('<a class="news-title" href="' + item.link + '"><span class="date">' + $.datepicker.formatDate('d M yy', new Date(item.date_gmt)) + '</span>' + item.title.rendered + '</a><br><a href="' + item.link + '">Read more &gt;</a>')
				);
			});
		}
	});
}

function getArticles() {
	var postURL = '/wp-json/wp/v2/articles?per_page=2&filter[meta_key]=date&filter[orderby]=meta_value&filter[order]=DESC';

	if (area_of_interest) {
		//   postURL = postURL + '&filter[post_type]=publictions&filter[practice_areas]=' + area_of_interest;
		postURL = postURL + '&filter[practice_areas]=' + area_of_interest;
	}


	$.getJSON(postURL, function (data) {
		//  if(debug) console.log(data);
		if (data.length < 1) {
			// console.log("I aint't got nuffin' guv!");
			$('.articles>ul').empty();
			$('.articles>ul').append(
				$(document.createElement('li')).html((area_of_interest_nicename ? area_of_interest_nicename + ' has' : 'There are') + ' no articles available, <a href="#" class="remove_personalisation_link">remove personalisation?</a>')
			);
			$('a.remove_personalisation_link').bind('click', function (e) {
				remove_personalisation_link();
				e.preventDefault();
			});
		} else {
			$('.articles>ul').empty(); // Remove existing articles
			// console.log(data);
			$(data).each(function (index, item) {
				$('.articles>ul').append(
					$(document.createElement('li')).html('<a class="news-title" href="' + (item.link_to && item.link_to.constructor && item.link_to.constructor === Object ? item.link_to.url : item.link_to) + '" target="_blank"><span class="date">' + item.date + '</span>' + item.text + '</a><br><a href="' + (item.link_to && item.link_to.constructor && item.link_to.constructor === Object ? item.link_to.url : item.link_to) + '" target="_BLANK">View Article</a>')
				);
			});
		}
	});
}

function getSeminars() {
	var dateObj = new Date();
	var meta_query = encodeURIComponent(JSON.stringify({ 'compare': '>==' }));
	// var postURL = '/wp-json/wp/v2/events?per_page=3&filter[meta_key]=date&filter[orderby]=meta_value&filter[order]=DESC&filter[meta_query][0][key]=date&filter[meta_query][0][compare]=' + encodeURIComponent('>=') + '&filter[meta_query][0][value]=' + today;
	var postURL = '/wp-json/events/v2/latest_events';
	if (area_of_interest) postURL = postURL + '?filter[practice_areas]=' + area_of_interest;
	$.getJSON(postURL, function (data) {
		//if(debug) console.log(data);
		if (data.length < 1) {
			//   console.log("I aint't got nuffin' guv!");
			$('.seminars>ul').empty();
			$('.seminars>ul').append(
				$(document.createElement('li')).html((area_of_interest_nicename ? area_of_interest_nicename + ' has' : 'There are') + ' no seminars available, <a href="#" class="remove_personalisation_link">remove personalisation?</a>')
			);
			$('a.remove_personalisation_link').bind('click', function (e) {
				remove_personalisation_link();
				e.preventDefault();
			});
		} else {
			$('.seminars>ul').empty(); // Remove existing articles
			$(data).each(function (index, item) {
				$('.seminars>ul').append(
					$(document.createElement('li')).html('<a class="news-title" href="' + item.link + '"><span class="date">' + item.date + '</span>' + item.title.rendered + '</a><br><a href="' + item.link + '">Read more &gt;</a>')
				);
			});
		}
	});
}


// (function sort_seminars_by_date() {
//   tinysort.defaults.order = 'asc';
//   tinysort('.event-items .event-item', '.event-item',{data:'datestamp'});
//   console.log('sorting seminars by date');
// })();

// Get posts on page load regardless of personalisation
jQuery(function ($) {

	if ($('#latest.js_dynamic_posts .news').length) {
		getNews();
	}
	if ($('#latest.js_dynamic_posts .articles').length) {
		getArticles();
	}
	if ($('#latest.js_dynamic_posts .seminars').length) {
		getSeminars();
	}
	if ($('.expertise-tiles').length) {
		expertiseTiles();
	}

	if ($('.scrollbox-wrapper > div').length) {
        var flkty = new Flickity( '.scrollbox-wrapper > div', {
            pageDots: false,
			prevNextButtons: true,	
			groupCells: true
        });
    }

});

window.onresize = function (event) {
	//	fullHero();
	if ($('.expertise-tiles').length) {
		expertiseTiles();
	}
};

//==================
// Full Height Hero
//==================
// Gets the height of the current window and subtracts the height
// of the header to provide the full size hero it's dimensions

// function fullHero() {
// 	$('.home-hero').height( $(window).innerHeight() );
// 	//$('.home-hero').css("margin-top",$('header').innerHeight());
// }

function expertiseTiles() {
	// var cw = $('.expertise-tiles>a>li').width() - 20;

	// $('.expertise-tiles>a>li').css({
	// 	'height': cw + 'px'
	// });

	// //reset
	// $('.expertise-tiles>a>li>span').removeClass('doubleLine');
	// //Offset text that is 2 lines or more to center it
	// $('.expertise-tiles>a').each(function () {
	// 	var txtHeight = $(this).find('li>span').height();
	// 	if (txtHeight > 25) {
	// 		$(this).find('li>span').addClass('doubleLine');
	// 	}
	// });
}

//=====================
// Smooth Scroll
//=====================

jQuery(function ($) {
	$('a[href*="#"]:not([href="#"])').click(function () {
		if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
			var target = $(this.hash);
			target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
			if (target.length) {
				$('html, body').animate({
					scrollTop: target.offset().top
				}, 1000);
				return false;
			}
		}
	});
});

// Accordian

jQuery.fn.ashCordian = function () {
	var $ = jQuery;
	var container = $(this);
	var target;
	container.find('header').click(function () {
		if ($(this).siblings('section').css('display') == 'block') {
			//container.find('section').slideUp(150);
			$(this).parent().parent().find('section').hide();
			$(this).parent().parent().find('header').removeClass('active');
		} else {
			//container.find('section').slideUp(150);
			//$(this).siblings('section').slideDown(150);

			$(this).parent().parent().find('section').hide();
			$(this).parent().parent().find('header').removeClass('active');

			$(this).siblings('section').show();
			$(this).addClass('active');

			var offset = $(this).offset();
			offset.top -= 100;

			$('html, body').animate({
				scrollTop: offset.top
			});

		}
	});
};

jQuery('.accordian').ashCordian();

//=====================
// Animate in Viewport
//=====================
// Plugin @RokoCB :: Return the visible amount of px
// of any element currently in viewport.
// stackoverflow.com/questions/24768795/
(function ($, win) {
	$.fn.inViewport = function (cb) {
		return this.each(function (i, el) {
			function visPx() {
				var H = $(this).height(),
					r = el.getBoundingClientRect(), t = r.top, b = r.bottom;
				return cb.call(el, Math.max(0, t > 0 ? H - t : (b < H ? b : H)));
			} visPx();
			$(win).on("resize scroll", visPx);
		});
	};
}(jQuery, window));



var Menu = {
	settings: {

	},

	init: function () {
		Menu = this.settings;
		this.slideMenu();
		//this.mainSubMenu();
	},

	slideMenu: function () {
		Menu = this.settings;

		window.menuFlag = false;

		var $ = jQuery;

		//if click outside of the navigation
		$(document).click(function (event) {
			//console.log(menuFlag);
			if (menuFlag) {
				if (!$(event.target).closest('#sidebar-navigation').length && !$(event.target).is('.menu-icon')) {
					if ($('#sidebar-navigation').is('.visible')) {
						$('#sidebar-navigation').removeClass('visible');
						// console.log(menuFlag);
						//  console.log('outside of menu clicked');
					}
				}
			}

		});

		$('.menu-icon').on('click', function () {
			$('#sidebar-navigation').addClass('visible');
			window.menuFlag = true;
		});

		$('.js-close-nav-trigger').on('click', function () {
			$('#sidebar-navigation').removeClass('visible');
			window.menuFlag = false;
		});



	},

	mainSubMenu: function () {
		Menu = this.settings;

		$('.menu-item-has-children').hover(function () {
			$(this).addClass('active');
			$(this).find('ul').fadeIn('fast');
		}, function () {
			$(this).removeClass('active');
			$(this).find('ul').fadeOut('fast');
		});
	}
};

Menu.init();

jQuery(document).ready(function ($) {
	"use strict";

	function testfnc(testcallback) {
		// console.log('test finction');
	}

	$('input.barrister-autocomplete').on('focus', function () {
		$(this).attr("placeholder", '');
	});

	$('input.barrister-autocomplete').on('focusout', function () {
		$(this).attr("placeholder", 'Search for a barrister');
	});

	$('input.barrister-autocomplete').autocomplete({

		source: function (term, response) {
			$.ajax({
				type: 'GET',
				dataType: 'json',
				url: '/wordpress/wp-admin/admin-ajax.php?action=get_listing_names&term=' + term['term'],
				success: function (data) {
					response(data);
					//   console.log(data);

					//   console.log(term['term']);
					dynamic_autocomplete_size();
				},

			});
		},

		select: function (event, ui) {
			//   console.log('selected' + ui.item.value);

			var selected_barrister = ui.item.value;
			var parsed_selected_barrister = selected_barrister.replace(/\s+/g, '-').toLowerCase();
			var base_url = '/barristers/'
			var fwd_path = base_url + parsed_selected_barrister;
			//   console.log('selected barrister is ' + selected_barrister);
			//   console.log('url path: ' + fwd_path);

			window.location.href = fwd_path;

		}


	});

	function dynamic_autocomplete_size() {
		var searchform, formWidth, autocompletebox;
		//  alert('te');
		searchform = $('.hero-search-form');

		autocompletebox = $('.ui-autocomplete');

		if (autocompletebox.length) {

			formWidth = searchform.innerWidth() + 'px';

			var xposition = $(searchform).offset();

			autocompletebox.css('min-width', formWidth);
			autocompletebox.css(xposition);


			// console.log('form width ' + formWidth);

		}
	};


	$(window).on('resize', function () {
		dynamic_autocomplete_size();
	});


	var s, barrister_filtering = {
		settings: {
			barrister_filter: $('.barrister-filter .filter select'),
			orderTrigg: $('.js-order-barristers'),
			areaTrigg: $('.js-filter-by-area'),
			languageTrigg: $('.js-filter-by-language'),
			nameTrigg: $('.js-barrister-name-filter'),
			spokenLang: $('.js-filter-by-spoken-lang')
		},

		init: function () {
			s = this.settings;
			this.order_barristers();
			this.select_filters();
			this.text_filter();
			this.loader();
		},

		loader: function () {
			if ($('.barristers-wrapper').length) {
				$(document).ready(function () {
					// $('.loading').fadeOut('fast');
					// $('.barristers-wrapper').fadeIn('fast');
					$('.js-filter-by-area').removeAttr('disabled');
					$('.js-filter-by-language').removeAttr('disabled');
					$('.js-filter-by-spoken-lang').removeAttr('disabled');
				});
			}
		},

		order_barristers: function () {

			$('.js-order-barristers').on('change', function () {

				var stringToSearch = "js-order-barristers";
				var value = $(this).val();

				sortOutPageString(stringToSearch, value);
				//   if (hash_parts.indexOf("&")) {
				//       var hash_parts = location.hash.split('&', 2);
				//   } else {
				//       var hash_parts = location.hash;
				//   }
				//   if (hash_parts.indexOf("&") === 1) {
				//       for(i in hash_parts) {
				//           if(hash_parts[i].indexOf("barrister_order") === 1) {
				//             var current_page_number = hash_parts[i].substr(15);
				//           }
				//       }
				//   } else {
				//       if(hash_parts.indexOf("barrister_order") === 1) {
				//           var current_page_number = hash_parts.substr(15);
				//       } else {
				//
				//       }
				//   }
				$(this).closest('.styled-select').addClass('active');

				if ($(this).val() == 'name') {
					$('.barrister-list').each(function (index, ele) {
						tinysort($(this).find('li'), { attr: 'data-name' });
						// console.log('Order Alphabetically');
					});
				} else {
					$('.barrister-list').each(function (index, ele) {
						if ($(this).parent().hasClass('kings-council')) {
							tinysort($(this).find('li:not(.clerk)'), { order: 'DESC', attr: 'data-priority' }, { attr: 'data-qc' }, { attr: 'data-call' }, { attr: 'data-name' });
						} else {
							tinysort($(this).find('li:not(.clerk)'), { order: 'DESC', attr: 'data-priority' }, { attr: 'data-call' }, { attr: 'data-name' });
						}
						// console.log('Order by Call');
					});
				}

			});

			if ($('body').is('.post-type-archive-barristers')) {
				$('.barrister-list').each(function (index, ele) {
					if ($(this).parent().hasClass('kings-council')) {
						tinysort($(this).find('li:not(.clerk)'), { order: 'DESC', attr: 'data-priority' }, { attr: 'data-qc' }, { attr: 'data-call' }, { attr: 'data-name' });
					} else {
						tinysort($(this).find('li:not(.clerk)'), { order: 'DESC', attr: 'data-priority' }, { attr: 'data-call' }, { attr: 'data-name' });
					}
					// console.log('Order by Call');
				});
			}

		},

		text_filter: function () {
			s = this.settings;

			$("#barrister_name_search").keyup(function () {

				//Reset the other filters
				// $(s.languageTrigg).prop('selectedIndex',0);
				// $(s.areaTrigg).prop('selectedIndex',0);
				s.barrister_filter.closest('.styled-select').removeClass('active');
				s.barrister_filter.prop('selectedIndex', 0);

				var _this = $(this);

				// Retrieve the input field text and reset the count to zero
				var filter = $(this).val(), count = 0;

				//
				// RegExp.escape = function(s) {
				//     return s.replace(/[-\/\\^'$*+?.()|[\]{}]/g, '\\$&');
				// };
				//
				// RegExp.escape($(this).val());
				//
				//
				//
				// console.log(new RegExp(filter, "i"));

				if ($('body').hasClass('post-type-archive-barristers')) {
					if (!_this.val()) {
						$('.barrister-list').css({'display':'none'});
						$('.barristers-group').removeClass('active');
					} else {
						$('.barrister-list').css({'display':'flex'});
						$('.barristers-group').addClass('active');
					}
				}

				// Loop through the comment list
				$('.barrister-list').each(function (index, ele) {
					$(this).closest('.barristers-group').removeClass('no_results');
					$(this).find('li').each(function (index) {
						// If the list item does not contain the text phrase fade it out
						if ($(this).text().search(new RegExp(filter, "i")) < 0) {
							$(this).hide();
							// Show the list item if the phrase matches and increase the count by 1
							if ($(this).closest('.barrister-list').children(':visible').length == 0) {
								//$(this).addClass('no_results');
								// console.log('no results ');
								$(this).closest('.barristers-group').addClass('no_results');
							} else {
								$(this).closest('.barristers-group').removeClass('no_results');
							}
						} else {
							$(this).show();
							count++;
						}
					});


				});

				//check if all groups are empty
				$('.barristers-wrapper').each(function (index, ele) {
					if (!$('body').hasClass('post-type-archive-barristers')) {
						if ($(this).children(':visible').length == 0) {
							$(this).addClass('no_results');
						} else {
							$(this).removeClass('no_results');
						}
					} else {

					}
				});

				// Update the count
				var numberItems = count;
				//$("#filter-count").text("Showing " + count + "barristers");
			});
		},

		select_filters: function () {
			s = this.settings;
			var flag, selected_option;

			flag = false;

			//Toggle dropdown

			$('.js-click-filter-by-area a').on('click', function(e){
				var _this = $(this);
				var stringToSearch = "js-filter-by-area";
				var value = $(this).attr('href');
				sortOutPageString(stringToSearch, value);
				$('.js-click-filter-by-area ul li.active').removeClass('active');
				_this.parent().addClass('active');
				$('.js-filter select[class="js-filter-by-area"]').val(value);
				$('.js-filter select[class="js-filter-by-area"]').prop("value", value);
				$('.js-filter select[class="js-filter-by-area"]').trigger("change");
				e.preventDefault();
			});

			$('.js-filter select').on('change', function (e) {

				var _this = $(this);

				if ($(this).parent().parent().hasClass('changePageFilter')) {
					var value = $(this).val()
					if ($(this).val() == 'area-all') {
						window.location.href = "../";
					} else {
						window.location.href = "../" + value.replace('area-', '');
					}
					e.preventDefault();
					return false;
				}

				e.preventDefault();

				if ($(this).hasClass('js-filter-by-language')) {
					var stringToSearch = "js-filter-by-language";
				} else if ($(this).hasClass('js-filter-by-spoken-lang')) {
					var stringToSearch = "js-filter-by-spoken-lang";
				} else {
					var stringToSearch = "js-filter-by-area";
				}
				var value = $(this).val();

				sortOutPageString(stringToSearch, value);

				if (flag) {
					//console.log('remove class of active from all filters');
					s.barrister_filter.closest('.styled-select').removeClass('active');
				}

				var searchClasses = [];

				$.each($('.js-filter select'), function () {
					var thisVal = $(this).val();
					searchClasses.push(thisVal);
					if (thisVal.search(/-all/i) >= 0) {
						$(this).parents('.styled-select').removeClass('active');
					} else {
						$(this).parents('.styled-select').addClass('active');
					}
				});

				var searchString = '';
				$.each(searchClasses, function(ind, className){
					searchString += '.' + className + '';
				});

				if ($('body').hasClass('post-type-archive-barristers')) {
					if (!_this.val() || _this.val() == 'area-all' || _this.val() == 'speak-all') {
						if ((_this.val() == 'area-all' && $('.js-filter-by-spoken-lang').val() == 'speak-all') || (_this.val() == 'speak-all' && $('.js-filter-by-area').val() == 'area-all')) {
							$('.barrister-list').css({'display':'none'});
							$('.barristers-group').removeClass('active');
						}
					} else {
						$('.barrister-list').css({'display':'flex'});
						$('.barristers-group').addClass('active');
					}
				}

				$('.barristers-group').removeClass('no_results');
				$('.barristers-wrapper').removeClass('no_results');
				$('.barrister-list li').hide();
				$('.barrister-list li' + searchString).show();

				var barrister_list_count = $('.barrister-list').length;
				var loopInd = 0;
				if (_this.val() != 'area-all' && _this.val() != 'speak-all') {
					$('.barrister-list').each(function () {
						loopInd++;
						if ($(this).children(':visible').length == 0) {
							$(this).closest('.barristers-group').addClass('no_results');
						} else {
							$(this).closest('.barristers-group').removeClass('no_results');
						}
						if (loopInd == barrister_list_count) {
							if (!$('.barristers-group:not(.no_results)').length) {
								$('.barristers-wrapper').addClass('no_results');
							}
						}
					});

				}

			});
		}
	};

	//Execute functions
	(function() {
		barrister_filtering.init();
		$('.js-order-barristers').trigger('change');
	})();
});

(function searchformtoggle(){
	var $ = jQuery;
	$('.js-search-form-trigger').on('click', function() {
	// console.log('clicked');

	if($(this).closest('.search-form-wrapper').find('.search-form').is('.form-visible')) {

		$(this).closest('.search-form-wrapper').find('.search-form').removeClass('form-visible');
		$('.search-form-wrapper .search-form input[type="submit"]').fadeOut('fast');
		$(this).closest('.search-form-wrapper').removeClass('active');
		$('.site-branding').removeClass('mobile-form-active');
		$('#masthead').removeClass('js-search-form-open');
	} else {
		$('#masthead').addClass('js-search-form-open');
		$(this).closest('.search-form-wrapper').addClass('active');
		$(this).closest('.search-form-wrapper').find('.search-form').addClass('form-visible');
		$('.search-form-wrapper .search-form input[type="submit"]').fadeIn('fast');
		$('.site-branding').addClass('mobile-form-active');
	}

	})
})();
  
(function toggleRecommendations(){
	var $ = jQuery;
	$('.js-recommendation-toggle').on('click', function(e) {
	// console.log('clicked');

	e.preventDefault();
	$(this).fadeOut();

	$('.recommendations').toggleClass('js-crop-recommendation');

	})
})();
  
  
  
jQuery(".fade-in").inViewport(function(px){
	if(px) $(this).addClass("triggeredCSS3") ;
});
(function() {
	function style_gravityform_elements(formName) {
		var $ = jQuery;
		var checkbox_field = $(formName).find('.gfield_checkbox');
		var radio_field = $(formName).find('.gfield_radio');

		// check if checkbox field exists
		if(checkbox_field.length) {
			//Activate the custom checkbox styling
			checkbox_field.addClass('custom-checkbox-style');

			$(formName).find('ul.gfield_checkbox>li').each(function() {
				var choice_id = $(this).find('input[type="checkbox"]').attr('id');
				$('<label class="tick-label" for="' + choice_id + '"></label>').insertAfter($(this).find('input[type="checkbox"]'));
			});
			//Show label for checkbox and radio buttons groups (if the labels are hidden for other fields by default)
			$(formName).find('.gfield_checkbox').closest('.gfield').find('.gfield_label').addClass('show_label');
			$(formName).find('.gfield_radio').closest('.gfield').find('.gfield_label').addClass('show_label');
		}

		// check if radiobutton field exists
		if(radio_field.length) {
			//Activate the custom checkbox styling
			radio_field.addClass('custom-radio-style');

			$(formName).find('ul.gfield_radio>li').each(function() {
				var choice_id = $(this).find('input[type="radio"]').attr('id');
				$('<label class="tick-label" for="' + choice_id + '"></label>').insertAfter($(this).find('input[type="radio"]'));
			});
			//Show label for checkbox and radio buttons groups (if the labels are hidden for other fields by default)
			$(formName).find('.gfield_checkbox').closest('.gfield').find('.gfield_label').addClass('show_label');
			$(formName).find('.gfield_radio').closest('.gfield').find('.gfield_label').addClass('show_label');
		}
	}

	//Re-attach gravityform styles after ajax load
	jQuery(document).bind('gform_post_render', function(event, formId){
		var formName = '#gform_' + formId;
		style_gravityform_elements(formName);
	});
})();

jQuery(function($) {

    if (!localStorage.getItem('cookie_warning_no_show')) {
        var cookie_clone = $('#cookie-modal').clone();
        $('#cookie-modal').remove();
        $('body').prepend(cookie_clone);
    }

    var hasBeenTrigged = false;
    $(window).scroll(function() {

        //check whether the user has scrolled the required distance and then show strip
        if ($(this).scrollTop() >= 300 && !hasBeenTrigged) {
            hasBeenTrigged = true;
            $('#direct-access-strip').addClass('strip-visible');
        }

        //If strip is visible, then hide before it overlaps the hero
        if (hasBeenTrigged) {
          if ($(this).scrollTop()  <= 400 ){
            // console.log('hide strip');
            $('#direct-access-strip').removeClass('strip-visible');
            hasBeenTrigged = false
          }
        }
    });

    if ($('#footnote').length) {
		$('.covid-popup-button > a').click(function(e) {
			e.preventDefault();

			$('#footnote').addClass('active');
			$('#footnote a:not(.linkedin_button)').bind('click', function(e){
				if ($(this).attr('href') != '#') {
					window.location.href = $(this).attr('href');
				} else {
					$('#footnote').removeClass('active');
				}
				e.preventDefault();
			});
		});


      $(document).keyup(function(e) {
        if (e.key === "Escape") { // escape key maps to keycode `27`
			if ($('#footnote').hasClass('christmas')) {
				$('#footnote').removeClass('active');
				setCookie('christmas_banner_dismissed', 1, 300);
			}
		  $('#footnote').removeClass('active');
		  	if ($('.follow-content').length) {
		  		setCookie('LinkedIn_Follow_close', 1, 0.1);
			}
        }
      });

      // var updated = 20200319;
      // var lastUpdated = localStorage.getItem('corona-warning-no-show-date');
      // if (!localStorage.getItem('corona-warning-no-show-' + updated)) {
      //   if (lastUpdated) {
      //     localStorage.removeItem('corona-warning-no-show-' + lastUpdated);
      //     localStorage.setItem('corona-warning-no-show-date', lastUpdated);
      //   }
      //   $('#corona-footnote').addClass('active');
      // } else {
      //   $('#corona-footnote').remove();
      // }
      // $('#corona-footnote a').bind('click', function(e){
      //   localStorage.setItem('corona-warning-no-show-' + updated, 1);
      //   if ($(this).attr('href') != '#') {
      //     window.location.href = $(this).attr('href');
      //   } else {
      //     $('#corona-footnote').removeClass('active');
      //   }
      //   e.preventDefault();
      // });
    }

	$('a.all-recommendations-link').bind('click', function(e){
		$('#recommendations-modal').addClass('active');
		var scrollY = window.scrollY;
		$('body').addClass('modal-visible');
		$('body').css({'top': '-' + scrollY + 'px'});
		e.preventDefault();
	});

	$('#recommendations-modal .close a').bind('click', function(e){
		$('#recommendations-modal').removeClass('active');
		var scrollY = $('body').css('top');
		$('body').removeClass('modal-visible');
		$('body').css({'top': ''});
		window.scrollTo(0, parseInt(scrollY || '0') * -1);
		e.preventDefault();
	});
});

///////////
// SNOW! //
///////////

var _createClass = function () {function defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}return function (Constructor, protoProps, staticProps) {if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;};}();function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}} // Happy Holidays!

// // Tweak this integer. The lower it is, more snow you'll create:
var amount = 20;

function rndIntBtwn(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}
function rndFloatBtwn(min, max) {
  return Math.random() * (max - min) + min;
}

var Snowfall = function () {

  function Snowfall(element) {_classCallCheck(this, Snowfall);
    var canvas = document.createElement('canvas');

    this.ctx = canvas.getContext('2d');
    this.counter = 0;
    this.particles = [];
    this.running = true;
    this.width = this.ctx.canvas.width;
    this.height = this.ctx.canvas.height;
    this.maxDiameter = 7;
    this.startY = -this.maxDiameter * 0.5;
    this.endY = this.height + this.maxDiameter * 0.5;
    this.showPaths = false;

    element.appendChild(canvas);

    window.addEventListener('resize', this.handleResize.bind(this));
    window.addEventListener('click', this.handleClick.bind(this));

    this.handleResize();
  }_createClass(Snowfall, [{ key: 'addParticle', value: function addParticle()

    {
      var x = rndIntBtwn(0, this.width);
      var y = this.startY;
      var diameter = rndIntBtwn(1, this.maxDiameter);
      // let color = `rgb(${rndFloatBtwn(0, 255)}, ${rndFloatBtwn(0, 255)}, ${rndFloatBtwn(0, 255)})`;
      var color = 'rgba(255, 255, 255, ' + rndFloatBtwn(0.8, 1) + ')';
      var particle = new Particle(this.ctx, x, y, diameter, color);
      this.particles.push(particle);
    } }, { key: 'handleClick', value: function handleClick(

    e) {
      var btn = e.target.closest('button');
      if (btn) {
        if (this.running) {
          this.running = false;
        //   btn.textContent = 'play';
        } else {
          this.running = true;
        //   btn.textContent = 'pause';
        }
        this.render();
      }
    } }, { key: 'handleResize', value: function handleResize()

    {
      this.ctx.canvas.width = this.width = window.innerWidth;
      this.ctx.canvas.height = this.height = window.innerHeight;
      this.endY = this.height + this.maxDiameter * 0.5;
    } }, { key: 'render', value: function render(

    time) {var _this = this;
      if (this.running) {
        // delta will be undefined on first run, so I'm setting it to zero, below. This wouldn't really make a difference, but the play/pause button would reset the animation on click of "play" if an undefined value were added to the mix.
        var delta = time ? time : 0;

        // throttle the amount of particles being added:
        if (this.counter > amount) {
          this.addParticle();
          this.counter = 0;
        }
        if (!this.showPaths) {
          this.ctx.clearRect(0, 0, this.width, this.height);
        }
        this.particles.forEach(function (p, i) {
          p.x += Math.sin(delta * p.freqFactor) * p.ampFactor;
          p.y += p.speed;
          p.draw();
        });
        // remove particles that are beyond the vertical bounds of the canvas:
        this.particles = this.particles.filter(function (p) {return p.y <= _this.height;});
        this.counter++;
        window.requestAnimationFrame(this.render.bind(this));
      }
    } }]);return Snowfall;}();var



Particle = function () {

  function Particle(context, x, y, diameter, color, speed) {_classCallCheck(this, Particle);
    this.color = color;
    this.ctx = context;
    this.glow = rndIntBtwn(2, 10);
    this.radius = diameter * 0.5;
    this.x = x;
    this.y = y;
    this.speed = diameter * 0.1; // smaller particles will be slower
    this.freqFactor = rndFloatBtwn(5, 9) * .0001;
    this.ampFactor = rndFloatBtwn(2, 5) * .1;
  }_createClass(Particle, [{ key: 'draw', value: function draw()

    {
      this.ctx.shadowBlur = this.glow;
      this.ctx.shadowOffset = 0;
      this.ctx.shadowColor = this.color;
      this.ctx.fillStyle = this.color;
      this.ctx.beginPath();
      this.ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2, false);
      this.ctx.closePath();
      this.ctx.fill();
    } }]);return Particle;}();

if ($("#masthead").hasClass('xmas')) {
	new Snowfall(document.documentElement).render();
}

window.onload = function() {
	var $ = jQuery;
	if ($('body').hasClass('single-newsletters')) {
		$('html').addClass('single-newsletters');
	}
}

jQuery(function($) {

	if ($('.barristers-group').length && $('body').hasClass('post-type-archive-barristers')) {
		$('.barristers-group .barrister-list').css({"display":"none", "max-height":"none"});
	}

	$('.barristers-group h3 a').bind('click', function(e){
		$(this).parents('.barristers-group').toggleClass('active');
		$(this).parents('.barristers-group').find('ul.barrister-list').slideToggle({
			start: function () {
			$(this).css({
				display: "flex"
			})
			}
		});
		// var barrister_list_item = $(this).parents('.barristers-group').find('ul.barrister-list li:first');
		// var style = window.getComputedStyle(barrister_list_item[0]);
		// var barristers_per_line = 1;
		// var total_barristers = barrister_list_item.parent().children().length;
		// var barrister_height = barrister_list_item.outerHeight();
		// switch (style.flexBasis) {
		// 	case '100%':
		// 		barristers_per_line = 1;
		// 	break;
		// 	case '50%':
		// 		barristers_per_line = 2;
		// 	break;
		// 	case '33.33%':
		// 		barristers_per_line = 3;
		// 	break;
		// }
		// var totalLines = Math.ceil(total_barristers / barristers_per_line);
		// var totalHeight = barrister_height * totalLines;
		// console.log(totalHeight);
		// var animation_time = ((totalHeight / 300) * .4);
		// console.log(animation_time);
		// $(this).parents('.barristers-group').find('ul.barrister-list')[0].setAttribute("data-animation-time", animation_time + "s");
		// $(this).parents('.barristers-group').find('ul.barrister-list')[0].setAttribute("data-max-height", totalHeight + 'px');
		// $(this).parents('.barristers-group').toggleClass('active');
		e.preventDefault();
	});

    var gallery = $('.gallery');
    gallery.find('.gallery-item').each(function() {
        $(this).attr('data-index', $(this).index());
    });

    if(gallery) {
        loadImages(gallery);
        registerArrowClicks();

        gallery.find('.gallery-icon > a').click(function(e) {
            e.preventDefault();
            var image_elem = $(this).find('img');
            var img_url = image_elem.attr('fullsize');
            var index = $(this).parent().parent().attr('data-index');

            openModal(index);
        });
    }

    $('.modal_content').click(function(e) {
        e.stopPropagation();
    });

    $('.modal_close, .modal_outer').not('.before, .after').click(function(e) {
        closeGalleryModal();
	});
	
	if ($('.vacancy-list').length) {
		$('.vacancy a.more').bind('click', function(e){
			$(this).parents('.vacancy').toggleClass('dropper-visible');
			if ($(this).parents('.vacancy').hasClass('dropper-visible')) {
				$(this).text('Hide Details');
			} else {
				$(this).text('See Details');
			}
			e.preventDefault();
			e.stopPropagation();
		});
	}

	function closeModal(e) {
		var scrollY = $('body').css('top');
		$('body').removeClass('modal-visible');
		$('body').css({'top': ''});
		window.scrollTo(0, parseInt(scrollY || '0') * -1);
		e.preventDefault();
	}

	$('.btn.subscribe').bind('click', function(e){
		var scrollY = window.scrollY;
		$('body').addClass('modal-visible').css({'top': '-' + scrollY + 'px'});
		e.preventDefault();
	});

	$('#subscribe-modal a.close').bind('click', function(e){
		closeModal(e);
	});

	$(document).keyup(function(e) {
		if (e.key === "Escape") { // escape key maps to keycode `27`
			if ($('body').hasClass('modal-visible')) {
				closeModal(e);
			}
	   }
	});

	$('#home-expertise').on('change', function(e){
		if ($(this).val() != '-1') {
			window.location.href = $(this).val();
		}
		e.preventDefault();
	});

	if ($('.follow-content').length || $('#footnote').hasClass('christmas')) {
		if ($('#footnote').hasClass('christmas')) {

			$('.christmas-hours a').bind('click', function(e){
				$('#footnote').addClass('active');
				e.preventDefault();
			});
			if (!getCookie('christmas_banner_dismissed')) {
				$('#footnote').addClass('active');
			}
		}
		$('.follow-content .message a').bind('click', function(e){
			setCookie('LinkedIn_Follow', 1, 365);
			window.open($(this).attr('href'), 'LinkedIn_Window');
			$('#footnote').removeClass('active');
			e.preventDefault();
			e.stopPropagation();
		});
		$('#footnote a.close').bind('click', function(e){
			setCookie('LinkedIn_Follow_close', 1, 0.1);
			if ($('#footnote').hasClass('christmas')) {
				setCookie('christmas_banner_dismissed', 1, 300);
				$('#footnote').removeClass('active');
			}
		});
	}

	if ($('body').hasClass('page-template-template-hub')) {

		if ($('.search-results-none').length) {
			$('.search-results').hide();
		}

		$('.btn.btn-more').bind('click', function(e){
			$(this).addClass('inactive');
			$(this).parent().parent().next().addClass('active');
			e.preventDefault();
		});
		$('.btn.btn-less').bind('click', function(e){
			$(this).addClass('inactive');
			var target = $(this);
			target.parent().parent().removeClass('active');
			window.setTimeout(function(){
				target.parent().parent().prev().find('a.btn.btn-more').removeClass('inactive');
				target.removeClass('inactive');
			}, 1000);
			e.preventDefault();
		});
		$('.mobile-extra-drop a.more').bind('click', function(e){
			$(this).addClass('inactive');
			$(this).parent().next().addClass('active');
			e.preventDefault();
		});
		$('.mobile-extra-drop a.less').bind('click', function(e){
			$(this).addClass('inactive');
			var target = $(this);
			target.parent().parent().removeClass('active');
			target.removeClass('inactive');
			window.setTimeout(function(){
				target.parent().parent().prev().find('a.more').removeClass('inactive');
			}, 800);
			e.preventDefault();
		});
		$('section.videos .article a').bind('click', function(e){
			$('.youtube-wrapper').addClass('active');
			var scrollY = window.scrollY;
    		$('body').addClass('modal-visible');
    		$('body').css({'top': '-' + scrollY + 'px'});
			var id = $(this).attr('data-id');
			if (!$("#youtube_player_script").length) {
				$('.youtube-content-inner-wrap').append('<div id="player" data-video_id="' + id + '"></div>');
				var script_tag = document.createElement('script');
				script_tag.src = "https://www.youtube.com/iframe_api";
				script_tag.setAttribute("id", "youtube_player_script");
				var firstScriptTag = document.getElementsByTagName('script')[0];
				firstScriptTag.parentNode.insertBefore(script_tag, firstScriptTag);
			} else {
				if ($('#player').attr("data-video_id") !== id) {
					$('#video-wrapper').removeClass('loaded').addClass('loading');
					$('#player').attr("data-video_id", id);
					player.loadVideoById(id);
				} else {
					$('#video-wrapper').addClass('loaded');
					player.playVideo();
				}
			}
			e.preventDefault();
		});
		$('.youtube-wrap .close').bind('click', function(e){
			$('.youtube-wrapper').removeClass('active');
			player.pauseVideo();
			var scrollY = $('body').css('top');
			$('body').removeClass('modal-visible');
			$('body').css({'top': ''});
			window.scrollTo(0, parseInt(scrollY || '0') * -1);
			e.preventDefault();
		});
		$('.subscribe-wrapper .cta a').bind('click', function(e){
			$('#hub-signup-overlay-wrapper').addClass('active');
			var scrollY = window.scrollY;
    		$('body').addClass('modal-visible');
    		$('body').css({'top': '-' + scrollY + 'px'});
			e.preventDefault();
		});
		$('#hub-signup-overlay-wrapper a.close').bind('click', function(e){
			$('#hub-signup-overlay-wrapper').removeClass('active');
			var scrollY = $('body').css('top');
			$('body').removeClass('modal-visible');
			$('body').css({'top': ''});
			window.scrollTo(0, parseInt(scrollY || '0') * -1);
			e.preventDefault();
		})
		$(document).keyup(function (e) {
            if (e.key === "Escape" && $('.youtube-wrapper').hasClass('active')) { // escape key maps to keycode `27`
				$('.youtube-wrapper').removeClass('active');
				player.pauseVideo();
                e.preventDefault();
            }
			if (e.key === "Escape" && $('#hub-signup-overlay-wrapper').hasClass('active')) { // escape key maps to keycode `27`
				$('#hub-signup-overlay-wrapper').removeClass('active');
                e.preventDefault();
            }
        });
	}
	$('.tab-list ul li a').bind('click', function(e){
		var target = $(this);
		var target_id = target.attr('href');
		$('.tab-list ul li').removeClass('active');
		target.parent().addClass('active');
		$('.content-tabs .tab.active').removeClass('active');
		$('.tab.' + target_id).addClass('active');
		e.preventDefault();
	});

	if ($('#brochure-notify').length) {
		console.log(my_ajax_object.ajax_url);
		$.ajax({
			type: 'GET',
			dataType: 'json',
			url: my_ajax_object.ajax_url,
			data: {
				action: 'check_brochure_notify'
			},
			success: function (data) {
				// response(data);
				console.log(data);
				if (data.count > 0) {
					$('#brochure-notify strong.count').html(data.count);
					$('#brochure-notify').show();
					$.each(data.brochure_data, function(id, barrister) {
						$('.add-to-brochure[data-id="' + id + '"]').addClass('added').html('<span class="icon-tick"></span> In your Shortlist');
					});
				}
			},

		});
	}

	if ($('.event-waiting-list-link').length) {
		$('.event-waiting-list-link').bind('click', function(e){
			$('.waiting-list-form').toggleClass('active');
			e.preventDefault();
		});
	}

	if ($('.leading-set-logos').length) {
		$('.leading-set-logos li').on('mouseenter, touchstart', function(e){
			$(this).find('.hover').css({'margin-left': '0'});
			if ($(this).find('.hover')[0].getBoundingClientRect().right > document.documentElement.clientWidth) {
				$(this).find('.hover').css({'margin-left': ($(this).find('.hover')[0].getBoundingClientRect().right - (document.documentElement.clientWidth - 16)) * -1});
			}
			if ($(this).find('.hover')[0].getBoundingClientRect().left < 0) {
				$(this).find('.hover').css({'margin-left': ($(this).find('.hover')[0].getBoundingClientRect().left - 16) * -1});

			}
			$(this).toggleClass('active');
			$('.leading-set-logos li').not($(this)).removeClass('active');
			$('.leading-set-logos li').not($(this)).find('.hover').css({'margin-left': '0'})
 			e.preventDefault();
		});
		$('.leading-set-logos li').on('mouseenter', function(){
			$('.leading-set-logos li').not($(this)).removeClass('active');
			$(this).find('.hover').css({'margin-left': '0'});
			if ($(this).find('.hover')[0].getBoundingClientRect().right > document.documentElement.clientWidth) {
				$(this).find('.hover').css({'margin-left': ($(this).find('.hover')[0].getBoundingClientRect().right - (document.documentElement.clientWidth - 16)) * -1});
			}
			if ($(this).find('.hover')[0].getBoundingClientRect().left < 0) {
				$(this).find('.hover').css({'margin-left': ($(this).find('.hover')[0].getBoundingClientRect().left - 16) * -1});
			}
		}).on('mouseleave', function(){
			$(this).find('.hover').css({'margin-left': ''});
		});
	}

	$('.expertise-nav-sidebar ul li.current-menu-ancestor').addClass('active');

	$('.expertise-nav-sidebar ul li.menu-item-has-children > a').on('click', function(e){
		e.preventDefault();
		//remove active class from all siblings
		$(this).parent().siblings().removeClass('active');
		$(this).parent().toggleClass('active');
	});

	$('.expertise-nav-sidebar > a:first-child').on('click', function(e){
		e.preventDefault();
		$('.expertise-nav-sidebar').toggleClass('active');
	});
});

window.onYouTubeIframeAPIReady = function() {
    player = new YT.Player('player', {
        height: '390',
        width: '640',
        videoId: $("#player").attr("data-video_id"),
        playerVars: {
            rel: 0, 
            showinfo: 0, 
            ecver: 2
        },
        events: {
            'onReady': onPlayerReady,
            'onStateChange': onPlayerStateChange
        }
    });
}

function onPlayerReady(event) {
    event.target.playVideo();
}
function onPlayerStateChange(event) {
    if (event.data == YT.PlayerState.PLAYING) {
        if ($('#collection-description .video-wrapper').length) {
            $('#video-overlay-wrapper').addClass('loaded').removeClass('loading');
        } else {
            $('#video-wrapper').addClass('loaded').removeClass('loading');
        }
    }
}

function loadImages(gallery) {
    gallery.find('.gallery-item').each(function() {
        var this_img = $(this).find('img');
        var this_img_url_large = this_img.attr('src');
        $(this_img).attr('fullsize', this_img_url_large);
        loadSingleImage($(this), this_img_url_large);
    });
}

function loadSingleImage(gallery_item, image_src) {
    $.ajax({
        'url': my_ajax_object.ajax_url,
        // List of chosen collection ID's
        'data': {
            'action': 'get_resized_image_from_url',
            'image_url_in': image_src,
            'size': 'gallery-thumbnail'
        },
        'method': 'POST'
    }).done(function(returned) {
        if (returned.response === 'success') {
            var found_img = returned.msg[0];
            gallery_item.find('img').prop('src', found_img);
            gallery_item.find('img').prop('srcset', found_img);
            gallery_item.addClass('image-loaded');
        }
    });

    return false;
}

function openModal(index) {
    $('.modal_content > img').attr('src', $('[data-index='+index+']').find('img').attr('fullsize')).load(function() {
        $('html').addClass('modal_open');
        var cur_index = parseInt(index);

        if(cur_index > 0) {
            $('.modal_content > .before').css('display', 'block');
            $('.modal_content > .before').attr('goto-index', (cur_index-1));
        } else {
            $('.modal_content > .before').css('display', 'none');
        }

        var max_index = $('.gallery-item').last().attr('data-index');
        if(cur_index < max_index) {
            $('.modal_content > .after').css('display', 'block');
            $('.modal_content > .after').attr('goto-index', (cur_index+1));
        } else {
            $('.modal_content > .after').css('display', 'none');
        }
	});
}

function registerArrowClicks() {
    $('.before, .after').click(function() {
        openModal($(this).attr('goto-index'));
    });
}

function closeGalleryModal() {
    $('html').removeClass('modal_open');
}

function isModalOpen() {
    return $('html').hasClass('modal_open');
}

function animateScroll() {
    jQuery('a').on('click', function(e){
        var href = $.attr(this, 'href');
        if (href.startsWith('#') && href !== '#') {
            smoothScrollToElement(href);

            e.preventDefault();
            return false;
        }
    });
}

animateScroll();

function smoothScrollToElement(location) {
    $('html,body').animate({
        scrollTop: $(location).offset().top - 30 // - $('header').height() - 20 // (3pb doesn't use a sticky header, commented out header adjustment)
    }, 1000);
}

function setCookie(cname, cvalue, exdays) {
	var d = new Date();
	d.setTime(d.getTime() + (exdays*24*60*60*1000));
	var expires = "expires="+ d.toUTCString();
	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
	var name = cname + "=";
	var ca = document.cookie.split(';');
	for(var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}